/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */

export const desktopContentSidePaddings = 34;
export const mobileContentSidePaddings = 8;
export const drawerDesktopFullWidth = 262;
export const drawerDesktopShrinkedWidth = 60;
export const maxContentWidth = 1700;
export const maxAccountAndInvoicesInnerContentWidth = 866;
export const maxAdminInvoicesInnerContentWidth = 1066;
